import * as yup from 'yup'

export const schema = yup.object().shape({
  name: yup.string().required('Campo obrigatório'),
  email: yup.string().required('Campo obrigatório').email('E-mail inválido'),
  phone: yup.string().notRequired(),
})
